<page-heading
  title="Fluxos"
  description="Crie e gerencie os fluxos de atendimento dos seus canais"
  />

<div class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-xs-12 col-md-6 input-trend-search">
            <input
              type="search"
              #searchBox
              class="form-control"
              placeholder="Pesquisar..."
              (keyup)="search(searchBox.value)"
              />
            <span class="mdi mdi-magnify search-icon ml-2"></span>
          </div>

          <div class="col-xs-12 col-md-3 btn-group trend-button">
            <button type="button" [matMenuTriggerFor]="filterStatus"
              class="btn btn-primary fw-bold mdi mdi-filter-variant dropdown-toggle">
              {{ statusLabel }}
            </button>
            <mat-menu #filterStatus="matMenu" class="custom-menu-panel">
              <button mat-menu-item (click)="changeStatus(null)">Todos</button>
              <button mat-menu-item (click)="changeStatus('true')">Publicado</button>
              <button mat-menu-item (click)="changeStatus('false')">Rascunho</button>
            </mat-menu>
          </div>

          <div class="col-xs-12 col-md-3 btn-group trend-button">
            <button class="btn btn-info fw-bold" (click)="openDialog()">
              + Adicionar Fluxo
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="card">
  @if (pager.total == 0) {
    <empty-records-component
      [message]="'Você ainda não tem fluxos'"
      [subMessage]="'Crie e configure seu primeiro fluxo'"
      [labelButton]="'+ Adicionar Fluxo'"
      [icon]="'mdi mdi-sitemap-outline'"
      (emitEvent)="openDialog()"
      />
  }

  @if (pager.total > 0) {
    <div class="card-body table-responsive">
      <table class="table table-hover table-centered mb-0">
        <thead>
          <tr>
            <th class="text-primary-emphasis">Nome</th>
            <th class="text-primary-emphasis">Descrição</th>
            <th class="text-primary-emphasis">Status</th>
            <th class="text-primary-emphasis">Criado em</th>
            <th><span class="sr-only"></span></th>
          </tr>
        </thead>
        <tbody>
          @for (item of pager.list; track item._id) {
            <tr role="button" (click)="edit(item._id)">
              <td>{{ item.name }}</td>
              <td class="text-muted">{{ item.description }}</td>
              <td>
                <span class="badge font-14"
                  [ngClass]="item.isPublished ? 'bg-success' : 'bg-secondary'">
                  {{ item.isPublished ? 'Publicado' : 'Rascunho' }}
                </span>
                <!-- RF-53: the flow currently drives one or more channels (hover lists them) -->
                @if (item.isActive) {
                  <span class="badge bg-soft-success text-success font-14 ms-1"
                    [title]="activeChannelsLabel(item)">
                    <i class="ri-flashlight-line me-1"></i>Ativo{{ (item.activeChannels?.length || 0) > 1 ? ' · ' + item.activeChannels.length + ' canais' : '' }}
                  </span>
                }
              </td>
              <td>{{ item.createdAt | timezoneDate: 'DD/MM/YYYY': getTimezoneCompanyCurrentUser() }}</td>
              <td>
                <div class="d-flex justify-content-end">
                  <button class="btn btn-dropdown-list" [matMenuTriggerFor]="actionsMenu" type="button"
                    (click)="$event.stopPropagation()" (mousedown)="$event.stopPropagation()">
                    <i class="mdi mdi-dots-vertical text-primary-emphasis"></i>
                  </button>
                  <mat-menu #actionsMenu="matMenu">
                    <button mat-menu-item tabindex="0" (click)="edit(item._id); $event.stopPropagation()">
                      Editar
                    </button>
                    @if (item.isPublished) {
                      <button mat-menu-item tabindex="0"
                        (click)="unpublish(item._id); $event.stopPropagation()">
                        Rascunho
                      </button>
                    }
                    <button mat-menu-item tabindex="0" (click)="delete(item._id); $event.stopPropagation()">
                      Excluir
                    </button>
                  </mat-menu>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
      @if (pager.total > pager.perPage) {
        <paginator [pager]="pager" (onPager)="loadPage($event)" />
      }
    </div>
  }
</div>
